"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensNameWithLensSuffix = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const lensNameWithLensSuffixAsString_1 = require("./lensNameWithLensSuffixAsString");
/**
 * Add "Lens" suffix to lens name where required.
 */
function LensNameWithLensSuffix({ lensName }) {
    const intl = (0, react_intl_1.useIntl)();
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, lensNameWithLensSuffixAsString_1.lensNameWithLensSuffixAsString)(intl, lensName) });
}
exports.LensNameWithLensSuffix = LensNameWithLensSuffix;
//# sourceMappingURL=LensNameWithLensSuffix.js.map